import { observable, action } from 'mobx';
import { setter } from 'mobx-decorators';
import agent from '../../services/web/agent';
import commonValidators from '../../services/validations/commonValidators';
import erorrHandler from '../../services/web/erorrHandler';

class SamlServiceProviderStore {

    formErrors = [];

    @setter @observable putSAMLServiceProviderProgress;

    @setter @observable getMetadataErrorMessage;
    @setter @observable getSAMLServiceProviderErrorMessage;
    @setter @observable putSAMLServiceProviderErrorMessage;

    @setter @observable issuerValidationMessage;

    @setter @observable certificateFile;
    @setter @observable certificateFileName;
    @setter @observable certificateSubject;
    @setter @observable certificatePassword;
    @setter @observable issuer;


    @action getMetadata() {

        return agent.SamlServiceProvider.getMetadata()
            .then(action(metadata => {
                
                return metadata;
            }))
            .catch(action(err => {

                this.getMetadataErrorMessage = erorrHandler.getErrorMessage(err);
            
                throw err;
            }));
    }


    @action get() {

        return agent.SamlServiceProvider.get()
            .then(action(samlServiceProvider => {

                return samlServiceProvider;
            }))
            .catch(action(err => {

                this.getSAMLServiceProviderErrorMessage = erorrHandler.getErrorMessage(err);
            
                throw err;
            }));
    }

    @action put() {

        this.putSAMLServiceProviderProgress = true;

        return agent.SamlServiceProvider.put(this.getModel())
            .then(action(_ => {}))
            .catch(action(err => {

                this.putSAMLServiceProviderErrorMessage = erorrHandler.getErrorMessage(err);
            
                throw err;
            }))
            .finally(action(_ => this.putSAMLServiceProviderProgress = false));
    }


    getModel = _ => {

        return {
            certificateFile: this.certificateFile,
            certificateFileName: this.certificateFileName,
            certificatePassword: this.certificatePassword || '',
            issuer: this.issuer
        };
    }

    validateIssuer() {

        const validation = commonValidators.validateGenericRequiredField(this.issuer);
        this.issuerValidationMessage = validation.errors.first('field');
        this.formErrors.push(validation.errorCount);
    }

    @action validateForm() { 

        this.formErrors = [];
        
        this.validateIssuer();   
        
        if (this.formErrors.filter(valid => valid > 0).length > 0) {
            
            return false;   
        }

        return true;
    }

    @action reset() {

        this.formErrors = [];

        this.getMetadataErrorMessage = '';
        this.getSAMLServiceProviderErrorMessage = '';
        this.putSAMLServiceProviderErrorMessage = '';

        this.issuerValidationMessage = '';

        this.certificateFile = undefined;
        this.certificateFileName = '';
        this.certificateSubject = '';
        this.certificatePassword = '';
        this.issuer = '';
    }
}

export default new SamlServiceProviderStore();



// WEBPACK FOOTER //
// ./src/stores/samlServiceProvider/index.js